export default __webpack_public_path__ + "static/media/scan2pay_content.719ff681.png";